import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '@core/services/userHandler/user.service';
import { environment } from '@environments/environment';
import { DialogModalComponent } from '@core/components/dialog-modal/dialog-modal.component';
import { RegexService } from '@core/services/regex.service';
import { RecaptchaComponent, RecaptchaModule } from 'ng-recaptcha';
import { RegisterComponent } from '../register/register.component';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { DataLayerService } from '@core/services/data-layer.service';

@Component({
  selector: 'cgw-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [MaterialModule, ReactiveFormsModule, RecaptchaModule, RegisterComponent, CommonModule],
})
export class LoginComponent implements OnInit {
  registerForm: UntypedFormGroup;
  changePassword: UntypedFormGroup;
  register = false;
  data: any;
  tokenCaptcha: string;
  auth2: any;
  message: string = null;
  userId: number;
  problemasSesionForm: UntypedFormGroup;
  recaptchaGoogle: string;
  firstStep: boolean = true;
  secondStep: boolean = false;
  thirdStep: boolean = false;
  hide: boolean = true;
  hide1: boolean = true;
  hide2: boolean = true;
  disclaimer: string = '';
  @Output() returnClose = new EventEmitter();
  @ViewChild('captchaRef', { static: true }) public captchaRef: RecaptchaComponent;
  @ViewChild('captchaRef2', { static: true }) public captchaRef2: RecaptchaComponent;
  @ViewChild('captchaRef3', { static: true }) public captchaRef3: RecaptchaComponent;
  @ViewChild('captchaRef5', { static: true }) public captchaRef5: RecaptchaComponent;
  constructor(
    private fb: UntypedFormBuilder,
    private regex: RegexService,
    public dialogRef: MatDialogRef<DialogModalComponent>,
    public dialogRef2: MatDialogRef<DialogModalComponent>,
    public dialog: MatDialog,
    private userService: UserService,
    private dataLayerService: DataLayerService,
  ) {
    console.log(this.userIngresado);
  }

  loginForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.pattern(this.regex.mail)]),
    contrasenia: new UntypedFormControl('', [Validators.required]),
  });

  public get userIngresado() {
    return this.loginForm.get('email');
  }
  public get password() {
    return this.loginForm.get('contrasenia');
  }

  ngOnInit(): void {
    this.recaptchaGoogle = environment.recaptcha_site;
  }
  comprobarMail(captcha) {
    this.dialogRef2 = this.dialog.open(DialogModalComponent, {
      width: 'auto',
      height: 'auto',
      maxWidth: '100vw',
      disableClose: true,
      data: { type: 'loadingBloq' },
    });
    const data = {
      mail_logueo: this.userIngresado.value.trim(),
      captchaResponse: captcha,
    };
    this.userService.checkUserByMail(data).subscribe(
      (res: any) => {
        if (res === null) {
          this.userIngresado.setErrors({ noUser: true });
          this.dialogRef2.close();
          return;
        }
        const hashId = environment.localDev ? res?.value?.hash_id : res?.hash_id;

        if (!res.fecha_caducidad_clave) {
          if (res && res.Data && res.Data !== null) {
            this.dialog.open(DialogModalComponent, {
              width: '460px',
              height: 'auto',
              maxHeight: '100%',
              maxWidth: '95vw',
              disableClose: true,
              data: { type: 'dobleMail', data: res.Data },
            });
            this.dialogRef2.close();
            return;
          }
          this.userId = hashId;
          this.firstStep = false;
          this.secondStep = true;
          this.disclaimer = '';
          this.password.reset();
          this.dialogRef2.close();
        } else {
          const date = Date.now();
          const dateValid = new Date(res.fecha_caducidad_clave).valueOf();
          this.firstStep = false;
          this.thirdStep = true;
          this.changePassword = this.fb.group(
            {
              codigo: ['', Validators.required],
              password: [
                '',
                [Validators.required, Validators.pattern(this.regex.passwordComplete)],
              ],
              passwordRep: ['', [Validators.required]],
            },
            {
              // check whether our password and confirm password match
              validator: RegexService.passwordMatchValidator,
            },
          );

          if (dateValid > date) {
            this.userId = hashId;
            this.message = null;
          } else {
            this.userId = hashId;
            this.message = 'El código temporal caducó, por favor pidalo nuevamente';
          }
          this.dialogRef2.close();
        }
        //this.captchaRef.reset();
      },
      (error) => {
        this.dialogRef2.close();
        this.userIngresado.setErrors({ noUser: true });
      },
    );
  }

  goToLoginFromRec() {
    this.secondStep = true;
    this.disclaimer = 'Si ingresas con tu antigua contraseña el código enviado se invalidará';
    this.password.reset();
    this.firstStep = false;
    this.thirdStep = false;
  }

  goToRegister() {
    this.register = true;
  }

  returnLogin(event) {
    if (!event) {
      this.register = false;
    } else {
      this.returnClose.emit(true);
    }
  }
  loginUser() {
    this.dialogRef2 = this.dialog.open(DialogModalComponent, {
      width: 'auto',
      height: 'auto',
      maxWidth: '100vw',
      disableClose: true,
      data: { type: 'loadingBloq' },
    });
    const data = {
      id: this.userId,
      clave: this.password.value,
    };
    this.userService.loginUser(data).subscribe(
      (res) => {
        if (res) {
          this.returnClose.emit(true);
          if (UserService.getUserValidado() == false) {
            this.dialog.open(DialogModalComponent, {
              width: '490px',
              height: 'auto',
              maxHeight: '100%',
              maxWidth: '95vw',
              disableClose: true,
              data: { type: 'validarMail' },
            });
          }
          this.dialogRef2.close();
        }
        //Evento google analytics
        this.dataLayerService.login(data.id);
      },
      (err) => {
        this.password.setErrors({ noPass: true });
        this.dialogRef2.close();
      },
    );
  }

  loginUserReset(captcha) {
    this.dialogRef2 = this.dialog.open(DialogModalComponent, {
      width: 'auto',
      height: 'auto',
      maxWidth: '100vw',
      disableClose: true,
      data: { type: 'loadingBloq' },
    });
    const data = {
      clave_temporal_hash: this.changePassword.value.codigo,
      clave: this.changePassword.value.password,
      captchaResponse: captcha,
    };
    this.userService.changePassword(data).subscribe(
      (res) => {
        if (res) {
          const dataUser = {
            id: this.userId,
            clave: this.changePassword.value.password,
          };
          this.userService.loginUser(dataUser).subscribe((res) => {
            if (res) {
              this.returnClose.emit(true);
              this.dialogRef = this.dialog.open(DialogModalComponent, {
                width: '440px',
                height: 'auto',
                maxWidth: '95vw',
                disableClose: true,
                data: { type: 'changePass' },
              });
              this.dialogRef.afterClosed().subscribe((res) => {
                this.returnClose.emit(true);
              });
            }
          });
        }
        this.dialogRef2.close();
      },
      (err) => {
        this.changePassword.controls.codigo.setErrors({ cod_error: true });
        this.dialogRef2.close();
      },
    );
  }

  remove() {
    this.secondStep = false;
    this.firstStep = true;
    this.thirdStep = false;
    this.userIngresado.setValue('');
    this.userIngresado.markAsUntouched();
  }

  sendPassword(captcha) {
    const data = {
      hash_id: this.userId,
      captchaResponse: captcha,
    };
    this.userService.getNewPass(data).subscribe((res) => {
      if (res) {
        this.dialogRef = this.dialog.open(DialogModalComponent, {
          width: '440px',
          height: 'auto',
          maxWidth: '100vw',
          disableClose: true,
          data: { type: 'sendPass' },
        });
        this.dialogRef.afterClosed().subscribe((res) => {
          this.returnClose.emit(true);
        });
      }
    });
  }
}
